require("./../sass/screen.scss");
var Loader = require('./Loader.js');

document.body.classList.add("loading");
var loader = new Loader();
loader.startLoaderText();

require.ensure(['./Telluric.js'], function (require) {
    var telluric = require('./Telluric.js');
    telluric.init();
});


var items = document.querySelectorAll(".talk__container .close, .social_icons .speaking");
for (var x=0; x<items.length;x++){
    items[x].addEventListener("click",function(e){
        document.querySelector(".talk__container").classList.toggle("open");
        document.querySelector(".hider").classList.toggle("open");
        e.preventDefault();
    });
}


document.querySelector(".hider").addEventListener("click",function(e){
    document.querySelector(".talk__container").classList.remove("open");
    document.querySelector(".hider").classList.remove("open");
    e.preventDefault();
});


document.addEventListener('keydown', function(e) {
    if (e.keyCode == 27) {
        document.querySelector(".talk__container").classList.remove("open");
        document.querySelector(".hider").classList.remove("open");
    }
});


//////////////////
// WEBPACK FOOTER
// ./js/entry.js
// module id = 0
// module chunks = 0